import { MARKUP_EVENT } from '../utils/constants';

export default function removeUserMarkupPopupEventListener(element: HTMLElement) {
    const UserMarkupPopupHandler = element[MARKUP_EVENT];
    if (UserMarkupPopupHandler) {
        element.removeEventListener('click', UserMarkupPopupHandler);
        element[MARKUP_EVENT] = null;
    }
}
